// Product rating from a Stamped.io metafield
const getRating = (product_data) => {
  let stamped = '';

  if (product_data.stampedBadge !== null && typeof product_data.stampedAverage !== 'undefined' && product_data.stampedAverage !== null && product_data.stampedAverage.value !== '0' && product_data.stampedAverage.value !== '0.0' && product_data.stampedAverage.value !== '0.00') {
    stamped = `<a href="/products/${product_data.handle}#stamped-main-widget"><span class="stamped-product-reviews-badge stamped-main-badge" data-id="${ product_data.id }" data-product-sku="${ product_data.handle }">${ product_data.stampedBadge.value.split('\"').join('"') } <span class="stamped-rating">${ parseFloat(product_data.stampedAverage.value, 10).toFixed(1) }</span></span></a>`;
  }

  return stamped;
};

// Afterpay placement widget
const getAfterpay = (current_variant) => {
  let $html = ``;

  // Now disabled on quickview
  return $html;

  if (window.theme.breakpoints.current === 'mobile') {
    return $html;
  }

  if (window.theme.currency_cart == window.theme.currency) {
    $html = `
      <afterpay-placement 
        data-locale="en_US"
        data-currency="${window.theme.currency}" 
        data-amount="${ Number(current_variant.price.amount)}"
        data-badge-theme="white-on-black"
        data-modal-theme="white"
      ></afterpay-placement>
    `;
  }
  
  return $html;
};

const getWishlistButton = (product, variant) => {
  const product_id = _.last(product.id.split('/'));
  const variant_id = _.last(variant.id.split('/'));

  if (typeof window.theme.customer.id === 'undefined') {
    return `
    <div class="swym-button-bar swym-wishlist-button-bar">
      <div class="swym-btn-container" data-position="default">
        <button aria-label="Add to Wishlist" id="swym-quick-view" class="swym-button swym-add-to-wishlist product_${product_id} swym-heart swym-loaded" data-swaction="addToWishlist" data-product-id="${product_id}" data-variant-id="${variant_id}" data-product-url="${ product.onlineStoreUrl }}" data-open-signin-actions-modal="wishlist"><span class="swym-wishlist-cta"></span></button>
      </div>
    </div>
  `;
  } else {
    return `
    <div class="swym-button-bar swym-wishlist-button-bar">
      <div class="swym-btn-container" data-position="default">
        <button aria-label="Add to Wishlist" id="swym-quick-view" data-with-epi="true" class="swym-button swym-add-to-wishlist product_${product_id}" data-swaction="addToWishlist" data-product-id="${product_id}" data-variant-id="${variant_id}" data-product-url="${ product.onlineStoreUrl }}"><span class="swym-wishlist-cta"></span></button>
      </div>
    </div>
  `;
  }
};

export {
  getRating,
  getAfterpay,
  getWishlistButton,
};
